import { createSelector } from 'reselect'

export const getParentId = (state, props) => props.cardContext.id

export const getIsCardArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getSubCard = (state, props) => {
  return state['view-card'].subCards[props.cardContext.id][props.id]
}

export default () => createSelector(
  [
    getSubCard,
    getParentId,
    getIsCardArchived
  ],
  (
    subCard,
    parentId,
    isCardArchived
  ) => ({
    ...subCard,
    parentId,
    isCardArchived
  })
)
